"use client";

import type { FC } from "react";
import type { ProviderFragment, SelectedProvider } from "../../../types";
import ProviderDropdownItem from "./ProviderDropdownItem";

type Props = {
  providers: ProviderFragment[];
  enabledProviders: SelectedProvider[];
  onToggleProvider: (provider: SelectedProvider) => void;
};

const ProviderDropdownList: FC<Props> = ({
  providers,
  enabledProviders,
  onToggleProvider,
}) => (
  <div className="w-full">
    {providers.map((provider) => {
      const name = provider.name || provider.handle || "";
      const selected: SelectedProvider = {
        handle: provider.handle || name,
        name,
      };
      return (
        <ProviderDropdownItem
          key={provider.id}
          provider={selected}
          count={provider.totalCount || 0}
          isSelected={enabledProviders.some((p) => p.name === name)}
          onToggle={onToggleProvider}
        />
      );
    })}
  </div>
);

export default ProviderDropdownList;
